var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPunchingBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.0127 139.333C53.2767 139.333 34.8457 125.512 34.8457 104.56C34.8457 86.5191 50.1081 73.7631 58.7288 50.3823C59.8234 47.4135 60.3707 45.9291 60.7911 45.1554C63.0392 41.0175 66.2169 38.9197 71.1911 38.2891C74.2299 37.9039 77.7936 37.9036 80.8317 38.2884C85.8072 38.9185 88.9853 41.0163 91.2342 45.1547C91.6541 45.9284 92.202 47.413 93.2964 50.3822C101.917 73.7618 117.179 86.5171 117.179 104.558C117.179 125.51 98.7481 139.333 76.0127 139.333Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0127 139.333C53.2767 139.333 34.8457 125.512 34.8457 104.56C34.8457 86.5191 50.1081 73.7631 58.7288 50.3823C59.8234 47.4135 60.3707 45.9291 60.7911 45.1554C63.0392 41.0175 66.2169 38.9197 71.1911 38.2891C74.2299 37.9039 77.7936 37.9036 80.8317 38.2884C85.8072 38.9185 88.9853 41.0163 91.2342 45.1547C91.6541 45.9284 92.202 47.413 93.2964 50.3822C101.917 73.7618 117.179 86.5171 117.179 104.558C117.179 125.51 98.7481 139.333 76.0127 139.333Z",
    stroke: "url(#paint0_linear_16725_944)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0482 88.6667C56.569 99.9261 61.1379 139.333 76.0059 139.333C90.8601 139.333 95.4695 99.9261 88.9753 88.6667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0482 88.6667C56.569 99.9261 61.1379 139.333 76.0059 139.333C90.8601 139.333 95.4695 99.9261 88.9753 88.6667",
    stroke: "url(#paint1_linear_16725_944)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9998 38.0001V22.1667M75.9998 22.1667L81.7967 20.7174C86.1572 19.6274 89.823 16.6866 91.8332 12.6667M75.9998 22.1667L70.2029 20.7174C65.8424 19.6274 62.1764 16.6866 60.1665 12.6667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9998 38.0001V22.1667M75.9998 22.1667L81.7967 20.7174C86.1572 19.6274 89.823 16.6866 91.8332 12.6667M75.9998 22.1667L70.2029 20.7174C65.8424 19.6274 62.1764 16.6866 60.1665 12.6667",
    stroke: "url(#paint2_linear_16725_944)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0125 57H57.0122",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0125 57H57.0122",
    stroke: "url(#paint3_linear_16725_944)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_944",
    x1: 34.8457,
    y1: 38,
    x2: 135.251,
    y2: 61.2335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_944",
    x1: 60.1792,
    y1: 88.6667,
    x2: 99.6149,
    y2: 95.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_944",
    x1: 60.1665,
    y1: 12.6667,
    x2: 96.2755,
    y2: 25.5213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_944",
    x1: 57.0122,
    y1: 57,
    x2: 57.4255,
    y2: 61.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPunchingBag);
export default __webpack_public_path__ + "static/media/punching-bag.a8ce65720265f71dc23169a08a3c1f44.svg";
export { ForwardRef as ReactComponent };